/* eslint-disable */
export default class Accordion {
    constructor(container) {
        this.container = container;
        this.headers = this.container.querySelectorAll('.card-header a');

        this.init();
    }

    init() {
        this.headers.forEach(header => {
            header.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = header.getAttribute('href').substring(1);
                const targetPanel = document.getElementById(targetId);
                const isExpanded = !header.classList.contains('collapsed');

                // Collapse all panels
                this.headers.forEach(h => {
                    const panel = document.getElementById(h.getAttribute('href').substring(1));
                    h.classList.add('collapsed');
                    h.setAttribute('aria-expanded', 'false');
                    panel.classList.remove('show');
                });

                // Expand the clicked panel if it was not already open
                if (!isExpanded) {
                    header.classList.remove('collapsed');
                    header.setAttribute('aria-expanded', 'true');
                    targetPanel.classList.add('show');
                }

                this.toggleIcons();
            });
        });

        this.toggleIcons(); // initial state
    }

    toggleIcons() {
        this.headers.forEach((header) => {
            const iconSpans = header.querySelectorAll('.toggle-icon span');
            if (!header.classList.contains('collapsed')) {
                iconSpans[0].style.display = 'none'; // "anzeigen"
                iconSpans[1].style.display = 'inline'; // "schließen"
            } else {
                iconSpans[0].style.display = 'inline';
                iconSpans[1].style.display = 'none';
            }
        });
    }
}
